import { createSlice } from "@reduxjs/toolkit";
import { defaultState } from "../../interfaces/auth";
import { getorganisationThunk } from "../../asyncThunks/scope/scope";


const initialState: defaultState = {
    error: null,
    data: null,
    loading: false,
};

export const getorganisation = createSlice({
    name: "getorganisation",
    initialState,
    reducers: {
        setScopeData: (state, action) => {
            state.data = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getorganisationThunk.pending, (state, action) => {
            state.error = null;
            state.loading = true;
        });
        builder.addCase(getorganisationThunk.fulfilled, (state, action) => {
            if (action?.payload?.status?.toLowerCase() === "success") {
                state.error = null;
                state.data = action.payload;
            } else {
                state.error = action?.payload;
                state.data = null;
            }
            state.loading = false;
        });
        builder.addCase(getorganisationThunk.rejected, (state, action) => {
            state.error = action.payload;
            state.data = null;
            state.loading = false;
        });
    },

})

export const { setScopeData } = getorganisation.actions;

export default getorganisation.reducer;